export const NOT_FOUND_REDIRECT_URL = 'https://rocketmortgage.com';
export const LOCAL_REDIRECT_URL = 'http://localhost:3000/mg6';
